import Bet1X2 from '../wager/bet/Bet1x2.js';
import BetChallenge from '../wager/bet/BetChallenge.js';
import BetFulltraff from '../wager/bet/BetFulltraff.js';
import BetNumboards from '../wager/bet/BetNumboards.js';
import BetScore from '../wager/bet/BetScore.js';
import BetSportkryss from '../wager/bet/BetSportkryss.js';
import type { IBoard, QuickPick } from './Board.js';
import type { ITSPayloadBet } from './ITSPayload.js';
import type { ITS_PRODUCT_ID, Product } from './Product.js';

export type BetProperty = XpertenBetProperty | 'GROUP' | 'GROUP_B2C' | 'COMPETITION' | 'REDUCERA_FRITT' | 'EGNARADER';

export type XpertenBetProperty = 'XPERTEN';

export interface IBet<TBoard extends IBoard> {
  product: Product;
  drawNumber: number;
  numberOfDraws: number;
  price: number;
  itsProductId: (typeof ITS_PRODUCT_ID)[keyof typeof ITS_PRODUCT_ID];
  productName: string;
  betProperties: readonly BetProperty[];
  isOwnRows: boolean;
  isQuickPick: boolean;
  quickPickValue?: 'XPERTEN' | QuickPick;
  rowPriceMulti: number;
  rowPrice: number;
  boards: IBoard[];
  addBoard(boardBuilderFn: (board: TBoard) => void): this;
  addBetProperty(property: BetProperty): this;
  compose(): ITSPayloadBet<object>;
  getSystemLabel(): string;
  toString(): string;
  setNumberOfDraws(numberOfDraws: number): this;
  setDrawNumber(drawNumber: number): this;
  setRowPrice(rowPrice: number): this;
  getRowCount(): number;
}

/**
 * Function to check if the provided bet is of type Bet1X2.
 *
 * @param bet The bet to check.
 * @returns true if the bet is of type Bet1X2, false otherwise.
 */
export function isBet1x2(bet: unknown): bet is Bet1X2 {
  return bet instanceof Bet1X2;
}

/**
 * Function to check if the provided bet is of type BetChallenge.
 *
 * @param bet The bet to check.
 * @returns true if the bet is of type BetChallenge, false otherwise.
 */
export function isBetChallenge(bet: unknown): bet is BetChallenge {
  return bet instanceof BetChallenge;
}

/**
 * Function to check if the provided bet is of type BetFulltraff.
 *
 * @param bet The bet to check.
 * @returns true if the bet is of type BetFulltraff, false otherwise.
 */
export function isBetFulltraff(bet: unknown): bet is BetFulltraff {
  return bet instanceof BetFulltraff;
}

/**
 * Function to check if the provided bet is of type BetNumboards.
 *
 * @param bet The bet to check.
 * @returns true if the bet is of type BetNumboards, false otherwise.
 */
export function isBetNumboards(bet: unknown): bet is BetNumboards {
  return bet instanceof BetNumboards;
}

/**
 * Function to check if the provided bet is of type BetScore.
 *
 * @param bet The bet to check.
 * @returns true if the bet is of type BetScore, false otherwise.
 */
export function isBetScore(bet: unknown): bet is BetScore {
  return bet instanceof BetScore;
}

/**
 * Function to check if the provided bet is of type BetSportkryss.
 *
 * @param bet The bet to check.
 * @returns true if the bet is of type BetSportkryss, false otherwise.
 */
export function isBetSportkryss(bet: unknown): bet is BetSportkryss {
  return bet instanceof BetSportkryss;
}
